import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";
import {
    FLUSH,
    PAUSE,
    PERSIST,
    persistReducer,
    persistStore,
    PURGE,
    REGISTER,
    REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import { developmentSlice } from "./developmentSlice";
import { microservicesApi } from "./microservicesApi";
import { selectionSlice } from "./selectionSlice";

const persistConfig = {
    key: "nextjs",
    storage,
    whitelist: ["selection", "planPayment"],
};

const rootReducers = combineReducers({
    [microservicesApi.reducerPath]: microservicesApi.reducer,
    development: developmentSlice.reducer,
    selection: selectionSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducers);

const makeStore = () => {
    const store = configureStore({
        reducer: {
            persistedReducer,
            [microservicesApi.reducerPath]: microservicesApi.reducer,
            development: developmentSlice.reducer,
            selection: selectionSlice.reducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
                },
            }).concat(microservicesApi.middleware),
    });
    store.__persistor = persistStore(store);
    return store;
};

export const wrapper = createWrapper(makeStore, { debug: process.env.NODE_ENV !== "production" });
